
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector"

import itaLang from './i18n/ita.json';
import engLang from './i18n/eng.json';

i18n  
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: 'en',
        nsSeparator: ':::',
        interpolation: {
            escapeValue: false
        },
        resources:{
            it: {
                translation: 
                    itaLang
                
            },
            en: {
                translation: 
                    engLang
                
            }
        }
    })

export default i18n;